var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('post-form',{attrs:{"tags":_vm.tags},on:{"on-save":function($event){return _vm.onSave()},"on-preview":function($event){return _vm.onPreview()}},model:{value:(_vm.post),callback:function ($$v) {_vm.post=$$v},expression:"post"}})}
var staticRenderFns = []

export { render, staticRenderFns }